import { format } from 'date-fns'
import {
	Button,
	Icon,
	Popover,
	PopoverContent,
	PopoverTrigger,
	Calendar,
} from '#app/ui/components'

type DateFilterProps = {
	selectedDate: Date | undefined
	onSelect: (date: Date | undefined) => void
	open: boolean
	onOpenChange: (open: boolean) => void
}

export function DateFilter({
	selectedDate,
	onSelect,
	open,
	onOpenChange,
}: DateFilterProps) {
	return (
		<div className="flex-1">
			<Popover open={open} onOpenChange={onOpenChange} modal={true}>
				<PopoverTrigger asChild>
					<Button
						variant="outline"
						role="combobox"
						aria-expanded={open}
						className="w-full"
					>
						<span className="truncate">
							{selectedDate ? format(selectedDate, `PPP`) : `Any Date`}
						</span>
						{selectedDate ? (
							<Icon
								name="cross-2"
								className="ml-2 h-4 w-4 shrink-0 cursor-pointer"
								onClick={(e) => {
									e.stopPropagation() // don't open the popover
									onSelect(undefined)
								}}
							/>
						) : (
							<Icon name="chevron-down" className="ml-2 h-4 w-4 shrink-0" />
						)}
					</Button>
				</PopoverTrigger>
				<PopoverContent>
					<Calendar
						mode="single"
						selected={selectedDate}
						onSelect={(date) => {
							onSelect(date)
							onOpenChange(false)
						}}
						initialFocus
					/>
				</PopoverContent>
			</Popover>
		</div>
	)
}
